import React from "react";
import { Container, PrimaryButton } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import { FormControlLabel, Switch, Toolbar } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { useGameContextContext } from "../../../../state/game-context/context";
import { useFootballContext } from "../../../../state/football-play/context";

const SwapTeamsSelector = () => {
	const { state, swapTeams: swapTeamsAction } = useGameContextContext();
	const { startOver } = useFootballContext();
	const areTeamsSwapped = state.swapTeams();

	// Swap Teams is a pure display toggle: apply it to the game context on change
	// so the field/teams flip immediately. Save just discards the pending Swap
	// Teams play and returns the wizard to play entry.
	const onToggle = (e) => {
		swapTeamsAction(e.target.checked);
	};

	const onSave = () => {
		startOver();
	};

	return (
		<Container fullHeight noPaper>
			<Box display="flex" justifyContent="center">
				<FormControlLabel
					control={
						<Switch
							id="swap-team-switch"
							color="primary"
							checked={!!areTeamsSwapped}
							onChange={onToggle}
						/>
					}
					label="Swap Teams?"
					labelPlacement="end"
				/>
			</Box>
			<Toolbar disableGutters variant="dense">
				<Grid
					container
					direction="row"
					justifyContent="flex-end"
					alignItems="center"
				>
					<Grid item>
						<PrimaryButton label="Save" onClick={onSave} />
					</Grid>
				</Grid>
			</Toolbar>
		</Container>
	);
};

export default SwapTeamsSelector;
